export default function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-primary-50 to-accent-50 rounded-2xl p-8 md:p-12">
          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3 whitespace-nowrap">
              APP下载
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
              被窝影院APP，随时随地追剧观影
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5 max-w-md">
              下载被窝影院APP，高清电影电视剧随身看。支持安卓与iOS双平台，界面清爽操作简便，缓存下载功能让您离线也能畅享精彩内容。最新地址首页直达，安全稳定不迷路。
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line text-base"></i>
                Android 下载
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-medium text-sm rounded-full transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line text-base"></i>
                iOS 下载
              </a>
            </div>
          </div>
          <div className="flex-shrink-0 w-40 h-40 md:w-52 md:h-52 rounded-2xl overflow-hidden bg-background-50 border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20showing%20movie%20streaming%20app%20interface%20with%20film%20posters%2C%20clean%20modern%20UI%20design%2C%20warm%20amber%20accents%2C%20cozy%20atmosphere%2C%20minimalist%20style%2C%20soft%20lighting%2C%20elegant%20composition&width=416&height=416&seq=app-qr-beiwo-01&orientation=squarish"
              alt="被窝影院APP界面展示"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}